module.exports = __webpack_public_path__ + "img/newsImg3-16.11472b37.png";